const tourReducer = (state = false, action) => {
  switch (action.type) {
    case 'START_TOUR':
      return true;
    case 'END_TOUR':
      return false;
    default:
      return state;
  }
};

export default tourReducer;
